/* ============================================================
   KaNi Candy - Klappfenster (siehe kani-klapp.css)
   Oeffnet ein .kani-klapp-Fenster aus einem Symbol heraus und schliesst es
   wieder dorthin. Genutzt von kani-suche.js und kani-warenkorb.js:

     KaniKlapp.oeffnen(fenster, symbol, { fokus: feld })
     KaniKlapp.zurueck()      schliesst ueber den Verlaufseintrag
     KaniKlapp.istOffen(fenster)

   Jedes offene Fenster legt einen Verlaufseintrag an: die Zurueck-Geste
   des Handys schliesst es dann, statt die Seite zu verlassen. Knoepfe mit
   data-kani-klapp-zu im Fenster schliessen es, ebenso Escape.
   ============================================================ */
window.KaniKlapp = (function(){
  'use strict';
  var html = document.documentElement;
  var STREIFEN = 64;
  var offen = null;   /* { fenster, symbol } */

  function flaecheVon(fenster){ return fenster.querySelector('.kani-klapp__flaeche'); }

  function vermessen(fenster, symbol){
    var r = symbol.getBoundingClientRect();
    var w = window.innerWidth, h = window.innerHeight;
    var mitte = Math.round(r.top + r.height / 2);
    var s = fenster.style;
    s.setProperty('--kk-mitte', mitte + 'px');
    s.setProperty('--kk-l', r.left + 'px');
    s.setProperty('--kk-t', r.top + 'px');
    s.setProperty('--kk-sx', (r.width / w).toFixed(4));
    s.setProperty('--kk-sy', (r.height / h).toFixed(4));
    s.setProperty('--kk-st', Math.max(0, mitte - STREIFEN / 2) + 'px');
    s.setProperty('--kk-ssy', (STREIFEN / h).toFixed(4));
  }

  /* Wartet auf das Ende der Flaechen-Animation. Ohne Animation (reduzierte
     Bewegung) kommt kein animationend - dann greift die Zeitgrenze. */
  function nachAnimation(fenster, fertig, grenze){
    var flaeche = flaecheVon(fenster);
    var erledigt = false;
    var einmal = function(){
      if (erledigt) return;
      erledigt = true;
      if (flaeche) flaeche.removeEventListener('animationend', einmal);
      fertig();
    };
    if (flaeche) flaeche.addEventListener('animationend', einmal);
    setTimeout(einmal, grenze);
  }

  function oeffnen(fenster, symbol, optionen){
    if (offen) return;
    optionen = optionen || {};
    offen = { fenster: fenster, symbol: symbol };
    vermessen(fenster, symbol);
    fenster.classList.remove('is-zu');
    fenster.hidden = false;
    fenster.classList.add('is-auf');
    symbol.setAttribute('aria-expanded', 'true');
    /* Der Fokus muss im selben Tipp passieren, sonst oeffnet iOS die
       Tastatur nicht. */
    var fokus = optionen.fokus || fenster.querySelector('[data-kani-klapp-zu]');
    if (fokus) fokus.focus({ preventScroll: true });
    try { history.pushState({ kaniKlapp: true }, ''); } catch (e) {}
    nachAnimation(fenster, function(){
      if (offen && offen.fenster === fenster) html.classList.add('kani-klapp-offen');
    }, 600);
    fenster.dispatchEvent(new CustomEvent('kani-klapp:auf'));
  }

  function schliessen(){
    if (!offen) return;
    var fenster = offen.fenster, symbol = offen.symbol;
    offen = null;
    if (document.activeElement && fenster.contains(document.activeElement)) document.activeElement.blur();
    vermessen(fenster, symbol);
    fenster.classList.remove('is-auf');
    fenster.classList.add('is-zu');
    symbol.setAttribute('aria-expanded', 'false');
    /* Scrollsperre und Fokus erst am Ende loesen - beides stoesst
       Neuberechnungen an, die mitten im Zuklappen ruckeln wuerden. */
    nachAnimation(fenster, function(){
      if (offen && offen.fenster === fenster) return;
      fenster.hidden = true;
      fenster.classList.remove('is-zu');
      html.classList.remove('kani-klapp-offen');
      symbol.focus({ preventScroll: true });
    }, 450);
  }

  /* Schliessen ueber den Verlaufseintrag, damit Knopf, Escape und die
     Zurueck-Geste denselben Weg nehmen. */
  function zurueck(){
    if (history.state && history.state.kaniKlapp) history.back();
    else schliessen();
  }

  /* Vor dem Verlassen der Seite aus dem Fenster heraus (Suche abschicken,
     Produkt antippen): den Verlaufseintrag zu einem gewoehnlichen machen.
     Sonst fuehrte die Zurueck-Geste auf der naechsten Seite erst zurueck in
     ein leeres Fenster. */
  function verlassen(){
    try { if (history.state && history.state.kaniKlapp) history.replaceState(null, ''); } catch (e) {}
  }

  document.addEventListener('click', function(e){
    if (!offen) return;
    if (e.target.closest('[data-kani-klapp-zu]') && offen.fenster.contains(e.target)) { zurueck(); return; }
    var link = e.target.closest('a[href]');
    if (link && offen.fenster.contains(link)) verlassen();
  });
  document.addEventListener('keydown', function(e){
    if (offen && e.key === 'Escape') zurueck();
  });
  window.addEventListener('popstate', function(){ if (offen) schliessen(); });

  /* Kommt man per Zurueck-Geste aus dem Browser-Cache auf die Seite, stuende
     das Fenster noch offen da - sofort zu, ohne Animation. */
  window.addEventListener('pageshow', function(e){
    if (!e.persisted || !offen) return;
    var fenster = offen.fenster, symbol = offen.symbol;
    offen = null;
    fenster.hidden = true;
    fenster.classList.remove('is-auf', 'is-zu');
    html.classList.remove('kani-klapp-offen');
    symbol.setAttribute('aria-expanded', 'false');
  });

  return {
    oeffnen: oeffnen,
    schliessen: schliessen,
    zurueck: zurueck,
    verlassen: verlassen,
    istOffen: function(fenster){ return !!offen && (!fenster || offen.fenster === fenster); }
  };
})();
